/**
 * Parse a Bible reference string like "John 3:16" or "1 Samuel 17:1-9" into
 * a structured verse object compatible with the dashboard's selectedVerse
 * shape. Returns null for un-parseable input.
 */
export const parseReferenceString = (ref) => {
  if (!ref || typeof ref !== 'string') return null;
  // Allow optional ordinal prefix (1/2/3) + book name + chapter[:verse[-end]]
  const m = ref.trim().match(/^((?:[1-3]\s)?[A-Za-z][A-Za-z\s]+?)\s+(\d+)(?::(\d+)(?:-(\d+))?)?$/);
  if (!m) return null;
  const book = m[1].trim();
  const chapter = parseInt(m[2], 10);
  const verse = m[3] ? parseInt(m[3], 10) : 1;
  return {
    book,
    chapter,
    verse,
    text: '',
    translation: 'KJV',
    reference: ref.trim(),
  };
};
